import { theme } from '@/theme'
import { AdaptiveTooltip } from '@surein/ui'
import { InfoIcon } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'
import { Row } from '../styled'

const InfoIconWrapper = styled(InfoIcon)`
  cursor: pointer;
  flex-shrink: 0;
`

const StyledRow = styled(Row)`
  align-items: center;
  gap: ${({ gap }) => gap || '4px'};
`

type WithInfoTextProps = {
  variant: 'primary' | 'secondary'
  children: React.ReactNode
  content: string
  alignItems?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'end'
    | 'start'
    | 'baseline'
    | 'stretch'
  gap?: string
}

export const WithInfoText = ({
  content,
  variant = 'primary',
  children,
  alignItems = 'start',
  gap = '4px',
}: WithInfoTextProps) => {
  const color = variant === 'primary' ? theme.color.info1 : theme.color.glass500

  return (
    <StyledRow alignItems={alignItems} gap={gap}>
      {children}
      <AdaptiveTooltip content={content}>
        <InfoIconWrapper size={16} color={color} />
      </AdaptiveTooltip>
    </StyledRow>
  )
}
